import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { ControleParticipacoesRow } from 'src/modules/motor-credito/serasa/serasa.pj.types'

export type ControleParticipacoesProps = {
    controleParticipacoes: ControleParticipacoesRow
}

export default function ControleParticipacoes({ controleParticipacoes }: ControleParticipacoesProps) {
    return (
        <>
            <Divider textAlign="center">Controle de Participações</Divider>
            {controleParticipacoes && (
                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    {controleParticipacoes.participacoes?.map((participacao, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem label="Nome" value={participacao.nome} xs={6} />
                            <GridItem label="CNPJ" value={participacao.cnpj} xs={6} />
                            <GridItem label="Cidade" value={participacao.cidade} xs={6} />
                            <GridItem label="UF" value={participacao.uf} xs={6} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
